// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgWaterIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M12.93 3.44a1.2 1.2 0 0 0-1.86 0C10.44 4.23 5 11.4 5 15c0 3.93 3.07 7 7 7s7-3.07 7-7c0-3.59-5.44-10.76-6.07-11.56M13 19c-.55 0-1-.45-1-1s.45-1 1-1c1.1 0 2-.9 2-2 0-.55.45-1 1-1s1 .45 1 1c0 2.21-1.79 4-4 4" />
  </g>
);
export default SvgWaterIcon;
SvgWaterIcon.displayName = 'SvgWaterIcon';
